import useSWR from 'swr';

import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { IStripeStatusResponse } from 'interfaces/stripe';

const useStripeStatus = () => {
  const clinicId = loadSelectedClinicId();

  const url = '/clinics/stripe/status';

  const { data, error, mutate } = useSWR<IStripeStatusResponse>(
    clinicId ? [url, clinicId] : null,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<IStripeStatusResponse>(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useStripeStatus;
